export enum PublicInfoImageLayout {
  HERO = "hero",
  SECTION = "section",
  COMPACT = "compact",
  /** Full image visible — no crop (product photos, hardware, etc.). */
  CONTAIN = "contain"
}
